var mentions_default = {
  "mentionPalette": "_9cbEC",
  "mention": "sqRXN",
  "mentionViewer": "i7nQQ",
  "mentionSuggestionsEntry": "v3XiU",
  "mentionSuggestionsEntryFocused": "vkXwd",
  "mentionSuggestionsEntryText": "tcEvE",
  "mentionSuggestionsEntryAvatar": "u8tS3",
  "mentionSuggestions": "QNyUW",
  "cursorDefault": "cIW4v",
  "cursorPointer": "_2xqnl"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
